import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { DropdownItem } from 'projects/admin/src/app/models/commonModel';
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}
@Component({
  selector: 'app-external-verification-tab',
  templateUrl: './external-verification-tab.component.html',
  styleUrls: ['./external-verification-tab.component.scss'],
})
export class ExternalVerificationTabComponent implements OnInit {
  @Input()
  QualificationTab!: FormGroup;
  @Input()
  QualificationTypes!: DropdownItem[];
  @Input()
  IsReadonly: boolean = false;
  @Input() verificationError: any;
  isEmailSaved = false;
  entityName: string = '';
  @Input()
  IsVerificationCorrection: boolean = false;
  matcher = new MyErrorStateMatcher();
  constructor() {}

  ngOnInit(): void {
    if (this.QualificationTab) {
      this.QualificationTab.disable();
      this.QualificationTab.controls['ExemptionFilingRequestId'].enable();
      this.QualificationTab.controls['birthDate'].enable();
      this.QualificationTab.controls['lastFourSocialSecurityNumber'].enable();
    }
  }

  ngOnChanges(): void {
    if (this.IsVerificationCorrection) {
      this.QualificationTab.controls['contactPhone'].enable();
      this.QualificationTab.controls['contactPhoneExtension'].enable();
      this.QualificationTab.controls['contactEmail'].enable();
      this.QualificationTab.controls['confirmEmail'].enable();
      this.QualificationTab.controls['birthDate'].disable();
      this.QualificationTab.controls['lastFourSocialSecurityNumber'].disable();
    }

  }
  numericOnly(e: { which: any; keyCode: any }) {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
